import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import { Session } from "../requests";
import { useNavigate } from "react-router-dom";

function Navigation({ currentUser, onSignOut, pickUps }) {
  const navigate = useNavigate();

  const handleSignOut = () => {
    Session.destroy().then(() => {
      onSignOut();
    });
  };

  const smallPickUps = pickUps?.filter((pickUp) => pickUp.size === "small")
  const largePickUps = pickUps?.filter((pickUp) => pickUp.size === "large")

  return (
    <Navbar bg="dark" variant="dark">
      <Navbar.Brand>Langley Food Bank</Navbar.Brand>
      <Nav className="mr-auto">
        {currentUser ? (
          <>
            <Nav.Link onClick={() => navigate("/clients")}>
              Client Index
            </Nav.Link>

            {currentUser.admin ? (
              <Nav.Link onClick={() => navigate("/clients/new")}>
                Add Client
              </Nav.Link>
            ) : (
              ""
            )}

            <Nav.Link disabled>Hello, {currentUser.name}</Nav.Link>

            <Button variant="outline-primary" onClick={handleSignOut}>
              Sign out
            </Button>
          </>
        ) : (
          <></>
        )}
        {currentUser ? (
          <div className="d-flex mx-5">
            <Nav.Link disabled>small pick ups: {smallPickUps?.length}</Nav.Link>
            <Nav.Link disabled>large pick ups: {largePickUps?.length}</Nav.Link>
            <Nav.Link disabled>
              total pick ups today: {smallPickUps?.length + largePickUps?.length}
            </Nav.Link>
          </div>
        ) : (
          ""
        )}
      </Nav>
    </Navbar>
  );
}

export default Navigation;
